<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>



// WEBPACK FOOTER //
// App.vue?f5385bf6